/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

export enum CashbackStatuses {
    NOT_RETURNED = 0,
    RETURNED = 1,
    TECHNICAL_ERROR = 2,
    INFO_NOT_AVAILABLE = 3,
}

export interface Cashback {
    returnRequestTransactionId: string;
    returnReturnTransactionId: string;
    returnStatus: CashbackStatuses;
    returnedAmount: number;
    returnedDate: string;
}

export const EDVGERIAL_INFO_STATUSES_TYPES = ['WAITING', 'COMPLETED', 'CANCELED', 'REJECTED'] as const;

export type EdvgerialInfoStatusType = (typeof EDVGERIAL_INFO_STATUSES_TYPES)[number];

export interface EdvgerialInfo {
    fiscalId: string;
    fin: string;
    accountId: string;
    channel: string;
    buyAmount: number;
    returnedAmount: number;
    returnedAmountCash: number;
    returnedAmountCashless: number;
    status: EdvgerialInfoStatusType;
    statusDate: string;
    cancelCode: string;
    cancelMessage: string;
    cancelDate: string;
    dvxStateCode: string;
    dvxStateMessage: string;
    dvxStateDate: string;
    refunded: true;
}

export interface TaxFreeInfo {
    fiscalId: string;
    invoiceSerial: string;
    invoiceNumber: string;
    name: string;
    surname: string;
    country: string;
    address: string;
    passportNumber: string;
    objectType: string;
    operationTime: string;
    operatorFin: string;
    totalAmount: number;
    customsRefund: number;
    bankRefund: number;
    refundType: string;
    customsGate: string;
}

export interface VatVerificationInfo {
    edvgerial: EdvgerialInfo[];
    taxFree: TaxFreeInfo[];
}
